var _style, _g, _g2, _path, _path2, _polyline, _polyline2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgNodeBodyWeb = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "NodeBodyWeb",
  x: "0px",
  y: "0px",
  viewBox: "0 0 320 400",
  style: {
    enableBackground: "new 0 0 320 400"
  },
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#000000;stroke-miterlimit:10.0001;}\r\n\t.st2{fill:none;stroke:#071F33;stroke-miterlimit:10;}\r\n\t.st3{fill:none;stroke:#071F33;stroke-width:8;stroke-miterlimit:10;}\r\n\t.st4{fill:none;stroke:#071F33;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st5{fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st6{fill:none;stroke:#071F33;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st7{fill:none;stroke:#50AD70;stroke-width:2;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M76.6,133l-38.9-10.4c0,0-7.5,38.9-2,59l41-4.2C76.6,177.3,72.4,160.6,76.6,133z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M55.2,196.6c0,0,6.4,23.5,16,38.9l-27.1,19.3c0,0-14.6-20.5-22.1-50.6L55.2,196.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M143.5,21.7c-7.8,2.5-15.8,5.7-24.1,9.7c-0.2,0-58.3,36.4-68.8,83.6l-10-3.4c0,0,15.9-55.6,74.9-87.8 c0,0,1.6-1,4.7-2.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M143.5,21.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M320.3,90.9c-11.2-21.4-29.7-43.5-59.9-59.5c0,0-7.5-4.8-20.6-9.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M320.3,90.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M320.4,75.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M259.4,20.8c2,1,3.9,2,5.9,3c0,0,31.2,16,55.1,51.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M259.4,20.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M120.3,21.3"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "93.4,122.6 60.3,110.4 64.9,100 95.5,115  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "69.1,92.5 75,82.6 103.9,103.7 100.1,111.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "108,96.8 112.6,92.1 86.4,67.4 80,76.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "116.4,87 122.6,82.2 99.7,54.8 91.7,62.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "128.5,78.2 134.8,73.6 115.1,43.5 107.1,48.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "122.6,39.3 132.2,34.7 146.5,67.4 139.8,70.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "139,31.4 149.9,26.8 160.7,60.8 153.1,64.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "166.6,60.8 174.9,58.7 168.6,23.4 157.8,26.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "174.9,21.8 186.6,21.8 186.6,56.9 180.8,56.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "193.9,21.8 205.1,21.8 202.5,56.9 193.9,56.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "213.8,23.4 226,26.8 215.9,60.8 208.4,56.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "221.8,60.8 229.7,64.8 242.7,33.1 232.2,26.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "234.3,67.4 241,70.9 259.4,42.2 249.3,34.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "246.9,73.6 253.1,78.2 276.1,52.8 267,43.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "259.4,82.2 264.8,87 290.3,64.8 281.6,56.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "269.4,92.5 274.9,100 304.6,78.2 295.8,67.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "307.5,83.7 312.6,93.3 282.4,111.2 276.1,104.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "284.5,115.8 287,123.8 320,111.2 316.7,101.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M320.2,118.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M320,130.5"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st0",
  points: "320.2,118.7 290.3,128.4 290.3,135.9 320,130.5  "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st0",
  points: "320,148.7 294.3,150.2 292.5,143.1 320,137.3  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M320,148.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M320,137.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M52.8,267.3l25.1-19.7c0,0,31.3,31.8,48,39.3L110,316.2C110.1,316.2,68.4,291.1,52.8,267.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M139,293.2l32.2,8.4l-4.1,30.9c0,0-21.8,2.1-36.9-8.8L139,293.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M320,160.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M320.3,201.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M320,160.1h-12.6c0,0,5.2,64.4-60.4,102.9c0,0-34.9,29.7-107.9,3c-0.1,0-37.4-10-62.5-76.9l-18.4,5.4 c0,0,10.9,60.6,74.1,89.9c0,0,58.1,31.4,124.7-2.6c0,0,45.4-23.4,63.3-80"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M84.2,135.9l19.7,5c0,0-15.9,60.2,38.5,95.4l-9.2,18.4C133.1,254.8,70.7,224.2,84.2,135.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M146.5,261.4L154,243c0,0,48.6,17.5,82.4-6.2c0,0,39.7-24.3,42.6-74.5h19.7c0,0,4.6,50.2-47.2,89.1 C251.5,251.4,215.9,285.3,146.5,261.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M107.1,129.3l-7.5-2.3c0,0,6.6-28.4,46.2-52.9c0.4-0.2,0.8-0.5,1.2-0.7c5.8-3.1,48.5-23.8,95.6,5 c0,0,42.6,29.7,44.4,73.9h-8.4c0,0-3.4-45-40.2-65.1c0,0-41.6-28.5-88.6-4.9C149.9,82.2,115.2,100,107.1,129.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M188.7,302.8c0,0,58.1,3.4,95.8-32.8l9.8,10.5c0,0-47.4,42.8-105.6,37L188.7,302.8L188.7,302.8z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "st0",
  cx: 190.3,
  cy: 161.6,
  r: 79.5
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "st1",
  cx: 190.3,
  cy: 161.8,
  rx: 45,
  ry: 45
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M208.9,218.3l6,19.9c0,0,19.1-7.3,26.3-15.2l-13.1-16.7C228.3,206.2,222.1,212.6,208.9,218.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M242.6,210.4c0,0,8.5-9.2,12.6-17.6l15.8,6.6c0,0-5,12-16,23.6L242.6,210.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M208.1,234.6l1.3,5.3c0,0-28.7,8.3-58.9-8.7c0,0-37.8-19-40.9-65.4c0,0-4-46.1,37.1-73l2.7,4.2 c0,0-38.6,22.1-35.1,69c0,0-0.3,37.3,38.6,61.5C152.9,227.5,184.6,242.9,208.1,234.6z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "199.7,213.9 203.5,231.6 197.7,232.5 196,215.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "193.2,232.7 187.3,232.8 188.7,214.5 193,214.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "184.5,214.6 181.2,213.9 177.5,232 183.1,232.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "178,213.5 174.1,212.1 168.4,229.7 174.1,231  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "170.8,210.7 167.1,209.2 159.4,226 163.8,228  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "155.5,223.8 150.8,220.9 161.2,205.8 164.6,207.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "147.5,219 142.5,215.4 154.5,201.3 158.2,203.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "152.8,198.8 149.7,195.8 135.9,208.1 140.4,211.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "133.5,205.9 130.3,200.7 145.6,191.1 147.2,193.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "128.2,197.5 125.3,192.6 141.3,184.2 143.6,187.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "123.5,188.3 121.7,182.2 139.4,177.2 139.7,181.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "137.7,174.7 137.3,170.1 119.9,173.1 120,179.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "137.1,167.4 136.9,163.6 119.3,163.4 118.8,169.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "136.4,160.2 136.7,156.2 119.4,153.2 117.8,159.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "136.7,152.4 137.4,148.8 120.7,143.7 119.7,149.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "138.5,145.2 140.3,140.8 122.7,133.8 120.3,140.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "124.3,131 127.1,126.2 143.1,134.4 141.8,139.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "144.6,132.2 147.4,129 132.8,118 129.7,122  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "135.3,115.2 148.4,126.2 151.8,124.2 139.8,111.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "141.8,108.3 146.4,103.9 156.9,118.6 154.4,121.3  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M274.1,192l-15.4-5.6c0,0,5.3-22.3,4-31.7l17.1-1C279.8,153.7,280.2,178.8,274.1,192z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M261.9,147.3l-5.1-16.3l14.6-6.6c0,0,6.9,9,6.2,18.6L261.9,147.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M233.4,203l7.4,6.5c0,0,23.5-21.3,19.1-56.9c0,0-2.2-34-35.2-53.8c0,0-33.6-19.9-72.3,2.6l5.4,8.7 c0,0,26.7-19.9,61.4-1.7c0,0,22.5,7.1,30.8,46.3C249.9,154.8,255.7,173.8,233.4,203z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M208.1,214.3l-3.2-10c0,0,30.6-9.5,31.1-42.8l10.5-1C246.7,160.4,250.3,196,208.1,214.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M245.9,152.7l-10.1,1.7c0,0-5.6-26-25.3-34.3c0,0-21.4-10.7-44.2,1.7l-5.4-8.6c0,0,20.7-15.7,51.8-3.7 C212.8,109.6,237.4,115.9,245.9,152.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M198.9,206l1,3.9c0,0-14.2,4.9-35.8-5.7c-0.2-0.1-0.4-0.2-0.6-0.3c-3-1.7-23.7-14.7-24-43 c0,0,1.3-26.7,20.1-39.6l2.2,3.7c0,0-18.8,13.8-17.4,35.3c0,0-1,26,22.1,40.1C166.7,200.3,183.9,210.6,198.9,206z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M252.5,123c0,0-14.4-26.3-40.5-32.8l1.9-7.1c0,0,31.7,9,45,36L252.5,123z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 190.4,
  cy: 160.9,
  r: 40.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 190.5,
  cy: 160.8,
  r: 23.2
})), /*#__PURE__*/React.createElement("circle", {
  className: "st3",
  cx: 190.4,
  cy: 161.8,
  r: 89.4
})))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 243.7,
  y1: 45.8,
  x2: 243.7,
  y2: 23.5
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 237.4,
  y1: 45.8,
  x2: 237.4,
  y2: 23.5
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M229.1,23.5v18.3c0,0,0.2,4.4,5.4,4.4H321"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M270.2,46.5v37.4c0,0,70.7,71.8,0,155.5v100.2v16.3c0,0,0.8,5.1,7.7,4.4h42.3"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M239.8,23.4h32.6C271,3.9,263.1,2,263.1,2h-72.9h-72.9c0,0-7.9,2.1-9.3,21.4h82.2H239.8"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M239.9,20.8h30.3C267.7,3.3,263,3.3,263,3.3h-72.2h-72.3c0,0-5.8-1-8.2,17.5h80.5H239.9"
})), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
  className: "st7",
  points: "301.6,42.3 306.6,47.3 311.5,42.3 "
})), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
  className: "st7",
  points: "301.2,357.3 306.2,362.2 311.1,357.3 "
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNodeBodyWeb, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/NodeBodyWeb.c985cddc.svg";
export { ForwardRef as ReactComponent };